"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorCorridaSchema = exports.ContadoresPublicacionesResponseSchema = exports.CeldaContadorSchema = exports.ListarEntrantesResponseSchema = exports.FilaEntranteSchema = exports.ResumenEntranteSchema = exports.PublicacionCandidataVistaSchema = exports.ConflictoVistaSchema = exports.DecisionVistaSchema = exports.AceptadoVistaSchema = exports.CandidatoVistaSchema = exports.EntranteResumenSchema = exports.RevistaVistaSchema = exports.MAX_CORRIDAS_FACETA = exports.FacetasPublicacionesResponseSchema = exports.FacetasQuerySchema = exports.ListarErroresQuerySchema = exports.LARGO_MENSAJE_GRUPO_ERROR = exports.ContadoresQuerySchema = exports.ListarEntrantesQuerySchema = exports.TAMANOS_PAGINA_PUBLICACIONES = exports.OrdenPublicacionesSchema = exports.ORDENES_PUBLICACIONES = exports.FiltrosEntranteSchema = exports.CAMPOS_EN_CONFLICTO = exports.IdentificadoresAutorSchema = exports.CandidatoUnidadSchema = exports.CandidatoInvestigadorSchema = exports.ESTADOS_POR_TAB = exports.EstadoFiltroPublicacionSchema = exports.ESTADOS_FILTRO_PUBLICACIONES = exports.TABS_DE_REVISION = exports.CASOS_POR_TAB = exports.CASOS_DECISION = exports.CasoPublicacionSchema = exports.CASOS_PUBLICACIONES = exports.TabPublicacionesSchema = exports.TABS_PUBLICACIONES = exports.TIPOS_ERROR_PUBLICACION = exports.FUENTE_POR_CODIGO_IMPORTACION = exports.CODIGOS_AUTOMATIZACION_PUBLICACIONES = exports.CODIGO_ERROR_VALOR_DISTINTO = exports.MetodoCoincidenciaAutorSchema = exports.OrigenDecisionAutorSchema = exports.EstadoDecisionPublicacionSchema = exports.TipoDecisionAutorSchema = exports.AccionPublicacionEntranteSchema = exports.EstadoPublicacionEntranteSchema = exports.FuenteDatosPublicacionSchema = exports.FUENTES_DATOS_PUBLICACION = void 0;
exports.CopiarIdentificadoresResponseSchema = exports.ColumnaIdentificadorSchema = exports.ResultadoLoteResponseSchema = exports.ResultadoItemSchema = exports.TipoFalloItemSchema = exports.CopiarIdentificadoresSchema = exports.CampoIdentificadorSchema = exports.DescartarEntrantesSchema = exports.ElegirAccionSchema = exports.DevolverConflictoSchema = exports.DecidirConflictoSchema = exports.DevolverDecisionSchema = exports.AceptarMejorCandidatoSchema = exports.DecidirUnidadSchema = exports.DecidirInvestigadorSchema = exports.DetalleEntranteResponseSchema = exports.ListarErroresResponseSchema = void 0;
exports.esOrigenInferido = esOrigenInferido;
exports.casosDeTab = casosDeTab;
exports.tabDeCaso = tabDeCaso;
exports.estadosPorDefecto = estadosPorDefecto;
exports.validarValorAceptado = validarValorAceptado;
exports.sumarCeldas = sumarCeldas;
exports.contarPor = contarPor;
const zod_1 = require("zod");
// ───────────── Publicaciones entrantes (R67 · purgatorio de publicaciones) ─────────────
//
// Contract of the admin review screen `/admin/publicaciones` over the three tables the
// bibliometric importer (Python, `/opt/automatizaciones`, NOT in this repo) writes:
//   publicacion_entrante   — one row per (fuente, uid) detected in a source
//   decision_autor         — who each author is (`investigador`) and under which unit (`unidad`)
//   conflicto_publicacion  — a field where the source contradicts the stored publication
//
// The admin only RESOLVES what the importer could not decide; the automation
// `aplicar_decisiones_publicaciones` is what writes `publicacion`. The DB CHECKs are the spec
// of every write (see prisma/ddl/r67_publicaciones_entrantes.sql):
//   · decision/conflict estado and value move TOGETHER (`por_revisar` ⇔ value IS NULL)
//   · every decision carries `origen` (the webapp always writes `admin`)
//   · `accion` only on an entrante that has `publicaciones_candidatas`
// "External author" is `ids_aceptados = []`, never NULL (NULL = undecided).
// ─── Enums mirrored from prisma/schema.prisma ───
exports.FUENTES_DATOS_PUBLICACION = ['WoS', 'Scopus', 'SciELO', 'OpenAlex'];
exports.FuenteDatosPublicacionSchema = zod_1.z.enum(exports.FUENTES_DATOS_PUBLICACION);
exports.EstadoPublicacionEntranteSchema = zod_1.z.enum(['pendiente', 'importada', 'descartada']);
exports.AccionPublicacionEntranteSchema = zod_1.z.enum(['crear_nueva', 'actualizar_existente']);
exports.TipoDecisionAutorSchema = zod_1.z.enum(['investigador', 'unidad']);
exports.EstadoDecisionPublicacionSchema = zod_1.z.enum(['por_revisar', 'por_aplicar', 'aplicado']);
exports.OrigenDecisionAutorSchema = zod_1.z.enum([
    'registro_fuente',
    'adscripcion_por_fecha',
    'publicacion_mas_cercana',
    'adscripcion_mas_reciente',
    'admin',
]);
exports.MetodoCoincidenciaAutorSchema = zod_1.z.enum(['orcid', 'uid_fuente', 'alias']);
/**
 * The three unit origins that are FILL-IN by the importer (the paper only said
 * "Universidad de Atacama"). A declared unit and an inferred one look identical in the
 * attribution table; this is what keeps the fill-in auditable.
 */
const ORIGENES_INFERIDOS = new Set([
    'adscripcion_por_fecha',
    'publicacion_mas_cercana',
    'adscripcion_mas_reciente',
]);
function esOrigenInferido(origen) {
    return origen != null && ORIGENES_INFERIDOS.has(origen);
}
/**
 * `code` of the 409 the identifier copy answers when the investigador already holds a DIFFERENT
 * value: the only identifier conflict an admin may force with `sobrescribir`. An ORCID owned by
 * another investigador is also a 409, without this code, and can never be forced.
 */
exports.CODIGO_ERROR_VALOR_DISTINTO = 'valor_distinto';
// ─── Automations and run errors ───
/**
 * `automatizacion.codigo` of the publication automations. HARD contract: the Python runner
 * requires the codigo to be exactly a directory name under its `automations/`.
 */
exports.CODIGOS_AUTOMATIZACION_PUBLICACIONES = [
    'importar_publicaciones_wos',
    'importar_publicaciones_scopus',
    'importar_publicaciones_openalex',
    'aplicar_decisiones_publicaciones',
    'regenerar_alias_investigadores',
];
/** Ingest automations and the source each one reads. The other two have no source. */
exports.FUENTE_POR_CODIGO_IMPORTACION = {
    importar_publicaciones_wos: 'WoS',
    importar_publicaciones_scopus: 'Scopus',
    /** Only works with a SciELO PID (SciELO through OpenAlex). */
    importar_publicaciones_openalex: 'OpenAlex',
};
/** `item_ejecucion_automatizacion.detalle.tipo_error` written by the importer. */
exports.TIPOS_ERROR_PUBLICACION = [
    'full_record_faltante',
    'publicacion_sin_autores_institucionales',
    'autor_con_multiples_ids_aceptados',
    'accion_sin_publicacion',
    'decision_no_aplicable',
    'revista_con_otro_issn',
    /** New journal whose ISSNs point to several stored journals: `{ids_revistas, issns}`. */
    'issns_de_varias_revistas',
    /** Existing publication: an ISSN to add already belongs to another journal: `{id_revista, ids_otras_revistas, issns}`. */
    'issn_de_otra_revista',
    /** OpenAlex: the work JSON is not in the backup: `{ruta}`. */
    'work_faltante',
    /** OpenAlex: SciELO domain outside the country dictionary: `{scielo_pid}`. */
    'pais_scielo_desconocido',
    'error_inesperado',
];
// ─── Review tabs and casos ───
//
// A pending item lands in exactly ONE caso. Precedence for a `por_revisar` investigador
// decision: afiliacion_incierta (the importer flagged a concrete doubt) → >1 candidates
// (autor_ambiguo) → 0 (autor_sin_candidatos) → exactly 1 (autor_candidato_unico: one
// candidate without enough confidence to accept it). A `por_revisar` unit decision is
// always `sin_unidad`. Rows of a `descartada` entrante never show up.
//
// Tabs (SIIV-75): «Coincidencias múltiples» and «Mismatch» are about WHO the authors are and
// WHICH publication it is; «Conflictos» is a field of an already stored publication (grouped by
// publication or journal); «Errores» are run errors (another endpoint, no batch actions);
// «Todas» lists the entrantes themselves.
exports.TABS_PUBLICACIONES = ['multiples', 'mismatch', 'conflictos', 'errores', 'todas'];
exports.TabPublicacionesSchema = zod_1.z.enum(exports.TABS_PUBLICACIONES);
exports.CASOS_PUBLICACIONES = [
    'autor_ambiguo',
    'publicacion_ambigua',
    'autor_sin_candidatos',
    'autor_candidato_unico',
    'afiliacion_incierta',
    'sin_unidad',
    'conflicto',
    'error',
];
exports.CasoPublicacionSchema = zod_1.z.enum(exports.CASOS_PUBLICACIONES);
/** Casos resolved over `decision_autor`. */
exports.CASOS_DECISION = [
    'autor_ambiguo',
    'autor_sin_candidatos',
    'autor_candidato_unico',
    'afiliacion_incierta',
    'sin_unidad',
];
exports.CASOS_POR_TAB = {
    multiples: ['autor_ambiguo', 'publicacion_ambigua'],
    mismatch: ['autor_sin_candidatos', 'autor_candidato_unico', 'afiliacion_incierta', 'sin_unidad'],
    conflictos: ['conflicto'],
    errores: ['error'],
    todas: [],
};
function casosDeTab(tab) {
    return exports.CASOS_POR_TAB[tab];
}
/** The tab a caso lives in (every caso belongs to exactly one). */
function tabDeCaso(caso) {
    const tab = Object.keys(exports.CASOS_POR_TAB).find((t) => exports.CASOS_POR_TAB[t].includes(caso));
    return tab ?? 'todas';
}
/** Tabs whose rows are decisions to take (the `/admin` badge counts their `por_revisar`). */
exports.TABS_DE_REVISION = ['multiples', 'mismatch', 'conflictos'];
/**
 * `?estado=` filter. In the review tabs it is the estado of the ROW (decision, conflict or the
 * «which publication» choice): `por_revisar` (default) or `por_aplicar`. In «Todas» it is the
 * estado of the ENTRANTE, exclusive and in this precedence for a pending one:
 *   por_revisar  something to decide (decision, conflict or candidate publications)
 *   trabada      an error in the latest finished run and nothing to decide: no other view shows it
 *   por_aplicar  decided, waiting for `aplicar_decisiones_publicaciones`
 *   en_espera    nothing to decide nor apply (the next run imports it)
 * plus `importada` and `descartada`.
 */
exports.ESTADOS_FILTRO_PUBLICACIONES = [
    'por_revisar',
    'por_aplicar',
    'trabada',
    'en_espera',
    'importada',
    'descartada',
];
exports.EstadoFiltroPublicacionSchema = zod_1.z.enum(exports.ESTADOS_FILTRO_PUBLICACIONES);
exports.ESTADOS_POR_TAB = {
    multiples: ['por_revisar', 'por_aplicar'],
    mismatch: ['por_revisar', 'por_aplicar'],
    conflictos: ['por_revisar', 'por_aplicar'],
    errores: [],
    todas: exports.ESTADOS_FILTRO_PUBLICACIONES,
};
/** Estado shown when the URL brings none: the review tabs open on what is left to decide. */
function estadosPorDefecto(tab) {
    return exports.TABS_DE_REVISION.includes(tab) ? ['por_revisar'] : [];
}
// ─── JSON written by the importer (snake_case, as stored) ───
exports.CandidatoInvestigadorSchema = zod_1.z.object({
    id_investigador: zod_1.z.number().int(),
    metodo: exports.MetodoCoincidenciaAutorSchema,
    /** null when metodo != 'alias' (an id identifies without scoring). */
    confianza: zod_1.z.number().nullable().optional().default(null),
    /** Alias format that matched, e.g. "N1 n2 A1 A2". null when metodo != 'alias'. */
    formato: zod_1.z.string().nullable().optional().default(null),
    coincide_unidad: zod_1.z.boolean().optional().default(false),
    nombres_no_concuerdan: zod_1.z.boolean().optional().default(false),
});
exports.CandidatoUnidadSchema = zod_1.z.object({ id_unidad: zod_1.z.number().int() });
/** Ids the source declared for the author, EVEN IF they did not identify them. */
exports.IdentificadoresAutorSchema = zod_1.z.object({
    uid_fuente: zod_1.z.string().nullable().optional().default(null),
    orcids: zod_1.z.array(zod_1.z.string()).optional().default([]),
});
// ─── conflicto_publicacion.campo → type of valor_aceptado ───
//
// Mirror of the importer's `CAMPOS_EN_CONFLICTO`. `campo` is a free VARCHAR in the DB and
// the importer only validates the two compound ones; the rest it learns from MariaDB's
// DataError, which sends the conflict back to review ("decided, looked saved, came back").
// Validating here BEFORE saving is what prevents that.
const textoNoVacio = (max) => zod_1.z.string().trim().min(1).max(max);
const issn = zod_1.z.string().length(9);
const fechaIso = zod_1.z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/)
    .refine((v) => {
    const d = new Date(`${v}T00:00:00Z`);
    return !Number.isNaN(d.getTime()) && d.toISOString().slice(0, 10) === v;
}, 'fecha inexistente');
exports.CAMPOS_EN_CONFLICTO = {
    /** [titulo, titulo_alternativo]; the principal cannot be null. */
    titulos: zod_1.z.tuple([textoNoVacio(500), zod_1.z.string().max(500).nullable()]),
    /**
     * Every ISSN of the journal (ordered, no nulls, at least one); it replaces the whole set in
     * `revista_issn`. The decision applies to the WHOLE journal. The importer does not check
     * the format, so only the length is validated.
     */
    issn_revista: zod_1.z
        .array(issn)
        .min(1, 'al menos un ISSN')
        .refine((l) => new Set(l).size === l.length, 'ISSN repetido')
        .transform((l) => [...l].sort()),
    /** The type DESCRIPTION, not its id. */
    tipo_publicacion: textoNoVacio(255),
    doi: textoNoVacio(250),
    año_publicacion: zod_1.z.number().int().positive().max(9999),
    fecha_early_access: fechaIso,
    fecha_indexacion: fechaIso,
    /** 0 | 1, never true/false: JSON_VALUE returns 'true' and that lands as 0 in a tinyint. */
    early_access: zod_1.z.union([zod_1.z.literal(0), zod_1.z.literal(1)]),
    volume: textoNoVacio(128),
    issue: textoNoVacio(128),
    page_start: textoNoVacio(128),
    page_end: textoNoVacio(128),
    page_count: textoNoVacio(128),
    article_number: textoNoVacio(128),
    // Valid but in practice never a conflict: titles are decided together as `titulos`.
    titulo: textoNoVacio(500),
    titulo_alternativo: textoNoVacio(500),
};
function validarValorAceptado(campo, valor) {
    const schema = Object.prototype.hasOwnProperty.call(exports.CAMPOS_EN_CONFLICTO, campo)
        ? exports.CAMPOS_EN_CONFLICTO[campo]
        : undefined;
    if (!schema) {
        return { ok: false, error: `El campo «${campo}» no se puede decidir desde el panel.` };
    }
    const r = schema.safeParse(valor);
    if (!r.success) {
        const detalle = r.error.errors.map((e) => e.message).join('; ');
        return { ok: false, error: `Valor inválido para «${campo}»: ${detalle}.` };
    }
    return { ok: true, valor: r.data };
}
// ─── Read contracts ───
const pageSchema = zod_1.z.coerce.number().int().min(1).default(1);
const pageSizeSchema = zod_1.z.coerce.number().int().min(1).max(100).default(25);
const textoBusqueda = zod_1.z
    .string()
    .trim()
    .max(200)
    .optional()
    .transform((v) => (v ? v : undefined));
/**
 * A multi-valued query param: `?x=a,b` or `?x=a&x=b` (Nest hands the repeated one as an array).
 * Trimmed, deduplicated, `[]` when absent.
 */
const listaQuery = (item) => zod_1.z
    .preprocess((v) => {
    if (v === undefined || v === null)
        return [];
    const crudos = (Array.isArray(v) ? v : [v]).flatMap((x) => String(x).split(','));
    return [...new Set(crudos.map((s) => s.trim()).filter(Boolean))];
}, zod_1.z.array(item))
    .default([]);
const booleanoQuery = zod_1.z
    .union([zod_1.z.boolean(), zod_1.z.enum(['true', 'false', '1', '0'])])
    .optional()
    .transform((v) => v === true || v === 'true' || v === '1');
const anioQuery = zod_1.z.coerce.number().int().min(1000).max(9999).optional();
/**
 * Filters over the ENTRANTE, shared by every listing and by the counters. They combine with AND;
 * inside one filter the values combine with OR.
 */
const filtrosEntranteShape = {
    /** One or more sources; none = all. */
    fuente: listaQuery(exports.FuenteDatosPublicacionSchema),
    /** Year of the entrante (`año_publicacion`), inclusive range; either end may be open. */
    anioDesde: anioQuery,
    anioHasta: anioQuery,
    /** Also (or, without a range, only) the entrantes with no year. */
    sinAnio: booleanoQuery,
    /** The run that brought or last touched the entrante (`id_ejecucion`). */
    idEjecucion: zod_1.z.coerce.number().int().positive().optional(),
    /**
     * Title, source uid (WoS UT, Scopus EID, OpenAlex work id), link, SciELO PID and DOI
     * (lowercased: DOIs are stored lowercase); in the decision casos also the author name.
     */
    q: textoBusqueda,
};
function validarRangoAnios(v, ctx) {
    if (v.anioDesde !== undefined && v.anioHasta !== undefined && v.anioDesde > v.anioHasta) {
        ctx.addIssue({ code: 'custom', path: ['anioDesde'], message: 'El año «desde» es posterior al año «hasta».' });
    }
}
exports.FiltrosEntranteSchema = zod_1.z.object(filtrosEntranteShape).superRefine(validarRangoAnios);
/** Order of a listing (SIIV-76). `recientes` = newest entrante first (the default). */
exports.ORDENES_PUBLICACIONES = ['recientes', 'anio', 'titulo'];
exports.OrdenPublicacionesSchema = zod_1.z.enum(exports.ORDENES_PUBLICACIONES);
/** Page sizes the screen offers. */
exports.TAMANOS_PAGINA_PUBLICACIONES = [25, 50, 100];
/** What a listing shows: the tab, its caso, the row estado and the entrante filters. */
const listadoShape = {
    tab: exports.TabPublicacionesSchema,
    /** One caso of the tab; default its first one. «Todas» has none. */
    caso: exports.CasoPublicacionSchema.optional(),
    /** See ESTADOS_FILTRO_PUBLICACIONES; default `estadosPorDefecto(tab)`. */
    estado: listaQuery(exports.EstadoFiltroPublicacionSchema),
    /** Only in «Conflictos»: one or more `conflicto_publicacion.campo`. */
    campo: listaQuery(zod_1.z.string().min(1).max(64)),
    ...filtrosEntranteShape,
};
function validarListado(v, ctx) {
    validarRangoAnios(v, ctx);
    if (v.caso !== undefined && !exports.CASOS_POR_TAB[v.tab].includes(v.caso)) {
        ctx.addIssue({ code: 'custom', path: ['caso'], message: `El caso «${v.caso}» no pertenece a la pestaña «${v.tab}».` });
    }
    if (v.campo.length > 0 && v.tab !== 'conflictos') {
        ctx.addIssue({ code: 'custom', path: ['campo'], message: 'El filtro «campo» sólo aplica a los conflictos.' });
    }
    const ajenos = v.estado.filter((e) => !exports.ESTADOS_POR_TAB[v.tab].includes(e));
    if (ajenos.length > 0) {
        ctx.addIssue({
            code: 'custom',
            path: ['estado'],
            message: `El estado «${ajenos.join(', ')}» no aplica a la pestaña «${v.tab}».`,
        });
    }
}
const conDefectos = (v) => ({
    ...v,
    caso: v.caso ?? exports.CASOS_POR_TAB[v.tab][0] ?? null,
    estado: v.estado.length > 0 ? v.estado : estadosPorDefecto(v.tab),
});
exports.ListarEntrantesQuerySchema = zod_1.z
    .object({
    ...listadoShape,
    orden: exports.OrdenPublicacionesSchema.default('recientes'),
    page: pageSchema,
    pageSize: pageSizeSchema,
})
    .superRefine((v, ctx) => {
    if (v.tab === 'errores') {
        ctx.addIssue({ code: 'custom', path: ['tab'], message: 'Los errores de corrida se listan en /errores.' });
        return;
    }
    validarListado(v, ctx);
})
    .transform(conDefectos);
/**
 * The counters take the entrante filters except `fuente`, which is a dimension of the matrix
 * (the source chips need every source at once).
 */
exports.ContadoresQuerySchema = zod_1.z
    .object(filtrosEntranteShape)
    .omit({ fuente: true })
    .superRefine(validarRangoAnios);
/** Untyped errors (`ParsingError`…) group by the first characters of their message. */
exports.LARGO_MENSAJE_GRUPO_ERROR = 120;
exports.ListarErroresQuerySchema = zod_1.z.object({
    fuente: listaQuery(exports.FuenteDatosPublicacionSchema),
    tipoError: zod_1.z.string().trim().min(1).max(64).optional(),
    /** Only the errors WITHOUT `tipo_error` (it ignores `tipoError`). */
    sinTipo: booleanoQuery,
    /** With `sinTipo`: one message group (the first LARGO_MENSAJE_GRUPO_ERROR characters). */
    mensaje: zod_1.z.string().max(exports.LARGO_MENSAJE_GRUPO_ERROR).optional(),
    /** `ultimas` = only the latest FINISHED run of each publication automation (default). */
    alcance: zod_1.z.enum(['ultimas', 'todas']).default('ultimas'),
    /** One run; it overrides `alcance` (an older run is not among the latest). */
    idEjecucion: zod_1.z.coerce.number().int().positive().optional(),
    /** Source uid or message. */
    q: textoBusqueda,
    page: pageSchema,
    pageSize: pageSizeSchema,
});
/**
 * Facets of the year and run filters (SIIV-76), counted over the rows of the listing the screen
 * shows: the same tab, caso, estado, campo and filters, except the facet's own filter (the year
 * facet ignores the year range, the run facet ignores the run). «Errores» counts run errors.
 */
exports.FacetasQuerySchema = zod_1.z.object(listadoShape).superRefine(validarListado).transform(conDefectos);
exports.FacetasPublicacionesResponseSchema = zod_1.z.object({
    /** Rows per `año_publicacion` (null = without year), newest first. Empty in «Errores». */
    anios: zod_1.z.array(zod_1.z.object({ anio: zod_1.z.number().int().nullable(), total: zod_1.z.number().int().positive() })),
    /** Rows per run, latest first (at most `MAX_CORRIDAS_FACETA`). */
    corridas: zod_1.z.array(zod_1.z.object({
        idEjecucion: zod_1.z.number().int().positive(),
        codigo: zod_1.z.string(),
        /** Start of the run, ISO. */
        fecha: zod_1.z.string().nullable(),
        total: zod_1.z.number().int().positive(),
    })),
});
/** Runs listed in the run facet (the latest ones). */
exports.MAX_CORRIDAS_FACETA = 30;
const UsuarioRefSchema = zod_1.z.object({ idUsuario: zod_1.z.number().int(), nombre: zod_1.z.string() });
/**
 * A stored journal (`revista_cientifica`), shown next to an ISSN conflict or error. Its ISSNs come
 * from `revista_issn` (R68), which does not tell print from electronic: sorted, possibly empty.
 */
exports.RevistaVistaSchema = zod_1.z.object({
    idRevista: zod_1.z.number().int(),
    titulo: zod_1.z.string().nullable(),
    issns: zod_1.z.array(zod_1.z.string()),
});
exports.EntranteResumenSchema = zod_1.z.object({
    idPublicacionEntrante: zod_1.z.number().int(),
    fuente: exports.FuenteDatosPublicacionSchema,
    uidFuente: zod_1.z.string(),
    titulo: zod_1.z.string().nullable(),
    anoPublicacion: zod_1.z.number().int().nullable(),
    link: zod_1.z.string().nullable(),
    /**
     * OpenAlex entrantes are processed as SciELO: `uidFuente` is the OpenAlex work id (`W…`) and
     * the publication gets the SciELO PID. Taken from the link; null for the other sources.
     */
    scieloPid: zod_1.z.string().nullable().default(null),
    estado: exports.EstadoPublicacionEntranteSchema,
    idPublicacion: zod_1.z.number().int().nullable(),
    accion: exports.AccionPublicacionEntranteSchema.nullable(),
    observaciones: zod_1.z.string().nullable(),
    idEjecucion: zod_1.z.number().int().nullable(),
    createdAt: zod_1.z.string(),
    updatedAt: zod_1.z.string(),
});
/** A candidate (investigador or unidad) enriched with its display name and its "why". */
exports.CandidatoVistaSchema = zod_1.z.object({
    id: zod_1.z.number().int(),
    /** null when the id no longer exists in the DB. */
    nombre: zod_1.z.string().nullable(),
    /** Public profile slug (investigador only). */
    slug: zod_1.z.string().nullable(),
    metodo: exports.MetodoCoincidenciaAutorSchema.nullable(),
    confianza: zod_1.z.number().nullable(),
    formato: zod_1.z.string().nullable(),
    coincideUnidad: zod_1.z.boolean().nullable(),
    nombresNoConcuerdan: zod_1.z.boolean().nullable(),
});
exports.AceptadoVistaSchema = zod_1.z.object({
    id: zod_1.z.number().int(),
    nombre: zod_1.z.string().nullable(),
    slug: zod_1.z.string().nullable(),
});
exports.DecisionVistaSchema = zod_1.z.object({
    numeroAutor: zod_1.z.number().int(),
    tipoDecision: exports.TipoDecisionAutorSchema,
    nombreAutor: zod_1.z.string(),
    estado: exports.EstadoDecisionPublicacionSchema,
    afiliacionIncierta: zod_1.z.boolean(),
    origen: exports.OrigenDecisionAutorSchema.nullable(),
    /** true for the three fill-in origins (see `esOrigenInferido`). */
    origenInferido: zod_1.z.boolean(),
    metodoCoincidencia: exports.MetodoCoincidenciaAutorSchema.nullable(),
    candidatos: zod_1.z.array(exports.CandidatoVistaSchema),
    /** null = undecided · [] = confirmed external · [x] = this investigador/unidad. */
    aceptados: zod_1.z.array(exports.AceptadoVistaSchema).nullable(),
    identificadoresAutor: zod_1.z.object({ uidFuente: zod_1.z.string().nullable(), orcids: zod_1.z.array(zod_1.z.string()) }).nullable(),
    observaciones: zod_1.z.string().nullable(),
    asignadoPor: UsuarioRefSchema.nullable(),
    fechaAsignacion: zod_1.z.string().nullable(),
    /**
     * The caso this decision lands in while `por_revisar` on a PENDING entrante; null otherwise
     * (a leftover `por_revisar` of an imported entrante never applies).
     */
    caso: exports.CasoPublicacionSchema.nullable(),
    /**
     * Other sources where a pending entrante has the same title + year (WoS and Scopus register
     * the same paper separately): deciding the author in one of them is enough. Listing only.
     */
    otrasFuentesPendientes: zod_1.z.array(exports.FuenteDatosPublicacionSchema).default([]),
});
exports.ConflictoVistaSchema = zod_1.z.object({
    campo: zod_1.z.string(),
    valorActual: zod_1.z.unknown(),
    valorEntrante: zod_1.z.unknown(),
    valorAceptado: zod_1.z.unknown().nullable(),
    estado: exports.EstadoDecisionPublicacionSchema,
    observaciones: zod_1.z.string().nullable(),
    asignadoPor: UsuarioRefSchema.nullable(),
    fechaAsignacion: zod_1.z.string().nullable(),
    /**
     * Only for `issn_revista`: how many pending ISSN conflicts of the SAME journal this
     * decision resolves (the importer closes them all). null for the other fields.
     */
    alcanceRevista: zod_1.z.number().int().nullable(),
    /** Only for `issn_revista`: the stored journal it belongs to (null when not linked). */
    revista: exports.RevistaVistaSchema.nullable().default(null),
});
exports.PublicacionCandidataVistaSchema = zod_1.z.object({
    idPublicacion: zod_1.z.number().int(),
    /** null when the candidate id no longer exists. */
    titulo: zod_1.z.string().nullable(),
    /** Effective year: COALESCE(año_publicacion, YEAR(fecha_early_access)). */
    anoPublicacion: zod_1.z.number().int().nullable(),
    /** true when the year comes from the early-access date. */
    anioEarlyAccess: zod_1.z.boolean().default(false),
    doi: zod_1.z.string().nullable(),
});
exports.ResumenEntranteSchema = zod_1.z.object({
    porRevisar: zod_1.z.number().int().nonnegative(),
    porAplicar: zod_1.z.number().int().nonnegative(),
    /**
     * Heuristic: `pendiente` + already linked to a publication stored as early access.
     * That is the early-access phase sending an imported row back (it is not terminal).
     */
    reabierta: zod_1.z.boolean(),
    /**
     * A pending entrante with an error in the latest FINISHED run of a publication automation:
     * it shows up in no review view (no decisions, candidates nor conflicts), only here.
     */
    trabada: zod_1.z.object({ tipoError: zod_1.z.string().nullable(), mensaje: zod_1.z.string().nullable() }).nullable().default(null),
});
exports.FilaEntranteSchema = zod_1.z.discriminatedUnion('tipo', [
    zod_1.z.object({ tipo: zod_1.z.literal('decision'), entrante: exports.EntranteResumenSchema, decision: exports.DecisionVistaSchema }),
    zod_1.z.object({ tipo: zod_1.z.literal('conflicto'), entrante: exports.EntranteResumenSchema, conflicto: exports.ConflictoVistaSchema }),
    zod_1.z.object({
        tipo: zod_1.z.literal('publicacion_ambigua'),
        entrante: exports.EntranteResumenSchema,
        candidatas: zod_1.z.array(exports.PublicacionCandidataVistaSchema),
    }),
    zod_1.z.object({ tipo: zod_1.z.literal('entrante'), entrante: exports.EntranteResumenSchema, resumen: exports.ResumenEntranteSchema }),
]);
exports.ListarEntrantesResponseSchema = zod_1.z.object({
    tab: exports.TabPublicacionesSchema,
    caso: exports.CasoPublicacionSchema.nullable(),
    /** The estados applied (the default ones when the URL brought none). */
    estado: zod_1.z.array(exports.EstadoFiltroPublicacionSchema).default([]),
    items: zod_1.z.array(exports.FilaEntranteSchema),
    total: zod_1.z.number().int().nonnegative(),
    page: zod_1.z.number().int().positive(),
    pageSize: zod_1.z.number().int().positive(),
});
/**
 * One non-empty cell of the counters matrix tab × caso × fuente × estado (SIIV-75). Every row the
 * listings can show is counted in exactly one cell, so any chip is a sum of cells.
 *   review tabs  caso = its caso; estado = `por_revisar` | `por_aplicar` (of the row)
 *   errores      caso = `error`; estado = null; latest finished run of each automation
 *   todas        caso = null; estado = the entrante's (see ESTADOS_FILTRO_PUBLICACIONES)
 */
exports.CeldaContadorSchema = zod_1.z.object({
    tab: exports.TabPublicacionesSchema,
    caso: exports.CasoPublicacionSchema.nullable(),
    /** null: a run error with no entrante, from an automation without a source (e.g. aplicar). */
    fuente: exports.FuenteDatosPublicacionSchema.nullable(),
    estado: exports.EstadoFiltroPublicacionSchema.nullable(),
    /** `conflicto`: the campo. `error`: the tipo_error (null = untyped). Otherwise null. */
    detalle: zod_1.z.string().nullable(),
    total: zod_1.z.number().int().positive(),
});
exports.ContadoresPublicacionesResponseSchema = zod_1.z.object({
    matriz: zod_1.z.array(exports.CeldaContadorSchema),
    /** `por_revisar` of the review tabs: the same number as the `/admin` badge (without filters). */
    porRevisar: zod_1.z.number().int().nonnegative(),
    /** What `aplicar_decisiones_publicaciones` would write now (`por_aplicar` of the review tabs). */
    porAplicar: zod_1.z.number().int().nonnegative(),
    /**
     * `aplicar_decisiones_publicaciones` is running: every decision write answers 409 until it
     * ends, so the web locks its decision buttons meanwhile.
     */
    aplicandoDecisiones: zod_1.z.boolean().default(false),
});
function coincide(valor, permitidos, vacioEsTodo = false) {
    if (permitidos === undefined)
        return true;
    if (vacioEsTodo && permitidos.length === 0)
        return true;
    return permitidos.includes(valor);
}
/** Sum of the matrix cells that match every given dimension. */
function sumarCeldas(matriz, f = {}) {
    let total = 0;
    for (const c of matriz) {
        if (coincide(c.tab, f.tab) &&
            coincide(c.caso, f.caso) &&
            coincide(c.fuente, f.fuente, true) &&
            coincide(c.estado, f.estado) &&
            coincide(c.detalle, f.detalle)) {
            total += c.total;
        }
    }
    return total;
}
/** Totals per value of one dimension (e.g. the `detalle` of the conflicts: per campo). */
function contarPor(matriz, dimension, f = {}) {
    const r = new Map();
    for (const c of matriz) {
        if (sumarCeldas([c], f) === 0)
            continue;
        r.set(c[dimension], (r.get(c[dimension]) ?? 0) + c.total);
    }
    return r;
}
exports.ErrorCorridaSchema = zod_1.z.object({
    idItem: zod_1.z.number().int(),
    idEjecucion: zod_1.z.number().int(),
    codigo: zod_1.z.string(),
    fecha: zod_1.z.string().nullable(),
    uidFuente: zod_1.z.string().nullable(),
    mensaje: zod_1.z.string().nullable(),
    /** null when the item has no typed detalle. */
    tipoError: zod_1.z.string().nullable(),
    detalle: zod_1.z.unknown().nullable(),
    /** The entrante with the same uid, when there is one. */
    idPublicacionEntrante: zod_1.z.number().int().nullable(),
    /**
     * `detalle.id_revista` resolved: the stored journal whose title matched with another ISSN
     * (`revista_con_otro_issn`) or the journal of the publication (`issn_de_otra_revista`).
     */
    revista: exports.RevistaVistaSchema.nullable().default(null),
    /** `ids_revistas` (`issns_de_varias_revistas`) or `ids_otras_revistas` (`issn_de_otra_revista`) resolved. */
    otrasRevistas: zod_1.z.array(exports.RevistaVistaSchema).default([]),
});
exports.ListarErroresResponseSchema = zod_1.z.object({
    /**
     * Groups: one per `tipo_error`; the untyped ones (tipoError null) one per message (its first
     * LARGO_MENSAJE_GRUPO_ERROR characters). Biggest first.
     */
    porTipo: zod_1.z.array(zod_1.z.object({
        tipoError: zod_1.z.string().nullable(),
        mensaje: zod_1.z.string().nullable().default(null),
        total: zod_1.z.number().int().nonnegative(),
    })),
    items: zod_1.z.array(exports.ErrorCorridaSchema),
    total: zod_1.z.number().int().nonnegative(),
    page: zod_1.z.number().int().positive(),
    pageSize: zod_1.z.number().int().positive(),
});
exports.DetalleEntranteResponseSchema = zod_1.z.object({
    entrante: exports.EntranteResumenSchema,
    resumen: exports.ResumenEntranteSchema,
    /** The linked publication, when the entrante already points to one. */
    publicacion: zod_1.z
        .object({
        idPublicacion: zod_1.z.number().int(),
        titulo: zod_1.z.string(),
        /** Effective year: COALESCE(año_publicacion, YEAR(fecha_early_access)). */
        anoPublicacion: zod_1.z.number().int().nullable(),
        anioEarlyAccess: zod_1.z.boolean().default(false),
        doi: zod_1.z.string().nullable(),
        earlyAccess: zod_1.z.boolean().nullable(),
    })
        .nullable(),
    decisiones: zod_1.z.array(exports.DecisionVistaSchema),
    conflictos: zod_1.z.array(exports.ConflictoVistaSchema),
    candidatas: zod_1.z.array(exports.PublicacionCandidataVistaSchema),
    /** Other entrantes (other sources) that point to the same publication. */
    hermanas: zod_1.z.array(exports.EntranteResumenSchema),
    /** Pending conflicts of those sibling entrantes: both versions side by side before deciding. */
    conflictosHermanas: zod_1.z
        .array(zod_1.z.object({ entrante: exports.EntranteResumenSchema, conflicto: exports.ConflictoVistaSchema }))
        .default([]),
    errores: zod_1.z.array(exports.ErrorCorridaSchema),
});
// ─── Write contracts (all bulk-capable) ───
const id = zod_1.z.number().int().positive();
const lote = (item) => zod_1.z.array(item).min(1).max(200);
exports.DecidirInvestigadorSchema = zod_1.z.object({
    items: lote(zod_1.z.object({
        idPublicacionEntrante: id,
        numeroAutor: zod_1.z.number().int().nonnegative(),
        /** null = the author is EXTERNAL (written as `[]`). */
        idInvestigador: id.nullable(),
    })),
});
exports.DecidirUnidadSchema = zod_1.z.object({
    items: lote(zod_1.z.object({ idPublicacionEntrante: id, numeroAutor: zod_1.z.number().int().nonnegative(), idUnidad: id })),
});
exports.AceptarMejorCandidatoSchema = zod_1.z.object({
    items: lote(zod_1.z.object({ idPublicacionEntrante: id, numeroAutor: zod_1.z.number().int().nonnegative() })),
});
exports.DevolverDecisionSchema = zod_1.z.object({
    items: lote(zod_1.z.object({
        idPublicacionEntrante: id,
        numeroAutor: zod_1.z.number().int().nonnegative(),
        tipoDecision: exports.TipoDecisionAutorSchema,
    })),
});
exports.DecidirConflictoSchema = zod_1.z.object({
    items: lote(zod_1.z
        .object({
        idPublicacionEntrante: id,
        campo: zod_1.z.string().min(1).max(64),
        usar: zod_1.z.enum(['entrante', 'actual']).optional(),
        valorAceptado: zod_1.z.unknown().optional(),
    })
        .superRefine((v, ctx) => {
        const tieneValor = v.valorAceptado !== undefined;
        if ((v.usar !== undefined) === tieneValor) {
            ctx.addIssue({ code: 'custom', message: 'Indicá «usar» o «valorAceptado» (uno de los dos).' });
        }
    })),
});
exports.DevolverConflictoSchema = zod_1.z.object({
    items: lote(zod_1.z.object({ idPublicacionEntrante: id, campo: zod_1.z.string().min(1).max(64) })),
});
exports.ElegirAccionSchema = zod_1.z
    .object({
    /** null = undo the choice (back to "publicación ambigua"). */
    accion: exports.AccionPublicacionEntranteSchema.nullable(),
    idPublicacion: id.optional(),
})
    .superRefine((v, ctx) => {
    if (v.accion === 'actualizar_existente' && v.idPublicacion === undefined) {
        ctx.addIssue({ code: 'custom', path: ['idPublicacion'], message: 'Elegí la publicación existente.' });
    }
    if (v.accion !== 'actualizar_existente' && v.idPublicacion !== undefined) {
        ctx.addIssue({ code: 'custom', path: ['idPublicacion'], message: 'Sólo «actualizar_existente» lleva publicación.' });
    }
});
exports.DescartarEntrantesSchema = zod_1.z.object({
    items: lote(zod_1.z.object({ idPublicacionEntrante: id })),
    observaciones: zod_1.z.string().trim().min(1, 'Indicá el motivo del descarte.').max(2000),
});
exports.CampoIdentificadorSchema = zod_1.z.enum(['orcid', 'uid_fuente']);
exports.CopiarIdentificadoresSchema = zod_1.z.object({
    idPublicacionEntrante: id,
    numeroAutor: zod_1.z.number().int().nonnegative(),
    idInvestigador: id,
    campos: zod_1.z.array(exports.CampoIdentificadorSchema).min(1).max(2),
    /** Which ORCID, when the source declared more than one. */
    orcid: zod_1.z.string().trim().min(1).max(19).optional(),
    /** Replace a different value already stored on the investigador. */
    sobrescribir: zod_1.z.boolean().optional().default(false),
});
exports.TipoFalloItemSchema = zod_1.z.enum(['no_disponible', 'no_encontrado', 'invalido', 'conflicto']);
exports.ResultadoItemSchema = zod_1.z.object({
    /** Position of the item in the request. */
    indice: zod_1.z.number().int().nonnegative(),
    ok: zod_1.z.boolean(),
    motivo: zod_1.z.string().nullable(),
    tipoFallo: exports.TipoFalloItemSchema.nullable(),
    /** Only for `issn_revista` conflicts (see ConflictoVista.alcanceRevista). */
    alcanceRevista: zod_1.z.number().int().nullable(),
});
exports.ResultadoLoteResponseSchema = zod_1.z.object({
    resultados: zod_1.z.array(exports.ResultadoItemSchema),
    aplicados: zod_1.z.number().int().nonnegative(),
    omitidos: zod_1.z.number().int().nonnegative(),
});
exports.ColumnaIdentificadorSchema = zod_1.z.enum(['orcid', 'wos_researcher_id', 'scopus_author_id']);
exports.CopiarIdentificadoresResponseSchema = zod_1.z.object({
    actualizados: zod_1.z.array(exports.ColumnaIdentificadorSchema),
    sinCambios: zod_1.z.array(exports.ColumnaIdentificadorSchema),
});
